import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { ChartContainerNoData } from "app/components/keyword-research/clicks-over-time-graph/styledComponents";
import { translate } from "app/filters/i18nFilter";

/**
 * History is capped at a rolling window of months; an interval reaching further back is answered
 * with a 400 and is a validation error rather than an empty chart.
 */
export const UnsupportedRangeNotice = () => (
    <ChartContainerNoData data-automation="ppc-spend-chart-unsupported-range">
        <Flex justifyContent="center">
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
            >
                {translate("website.analysis.search.overview.graph.ppc.date.range.unsupported")}
            </Text>
        </Flex>
    </ChartContainerNoData>
);
